
    var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',_vm._g({attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"24","height":"24","viewBox":"0 0 24 24"}},_vm.$listeners),[_c('path',{attrs:{"d":"M0,0H24V24H0Z","fill":"none"}}),_c('path',{attrs:{"d":"M17,6.209,15.791,5,11,9.791,6.209,5,5,6.209,9.791,11,5,15.791,6.209,17,11,12.209,15.791,17,17,15.791,12.209,11Z","transform":"translate(1 1)"}})])}
var staticRenderFns = []

    export default {
      render: render,
    }
  